import { ReactNode, useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { loadSettings } from "src/services/configService";

type Props = { children: ReactNode };

export const ConfigLoader = ({ children }: Props) => {
    const { t } = useTranslation();
    const [ready, setReady] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        loadSettings()
            .then(() => setReady(true))
            .catch((err: unknown) => {
                setError(err instanceof Error ? err : new Error(String(err)));
            });
    }, []);

    if (error) {
        return (
            <div role="alert" style={{ padding: 24, fontFamily: "sans-serif" }}>
                <h1>{t("error.configUnavailable.title")}</h1>
                <p>
                    <Trans i18nKey="error.configUnavailable.message" components={{ code: <code /> }} />
                </p>
                <p>{error.message}</p>
            </div>
        );
    }

    if (!ready) {
        return null;
    }

    return <>{children}</>;
};
